












import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'course-iter',
})
export default class CourseIter extends Vue { }
